// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2Ewlz","dragIcon":"Choice_dragIcon__2UlSW","left":"Choice_left__3XotU","input":"Choice_input__1bwYv"};